import { useNavigate } from "react-router-dom";
import { MapPin, Layers, Play } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { priceMain, priceBox, priceActual, discountPct, stockUnit } from "@/lib/format";
import { Badge } from "@/components/ui/badge";

export default function ProductCard({ p, index = 0, b2b = false }) {
  const nav = useNavigate();
  return (
    <div
      data-testid={`tile-product-card-${p.id}`}
      onClick={() => !b2b && nav(`/product/${p.id}`)}
      className="group cursor-pointer bg-card rounded-2xl border overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
      style={{ animationDelay: `${index * 40}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
        <img
          src={fileUrl(p.catalogue_image)}
          alt={p.title}
          className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <Badge className="absolute top-3 left-3 bg-black/70 text-white border-0 backdrop-blur font-semibold">
          {p.surface}
        </Badge>
        {discountPct(p) != null && (
          <Badge data-testid={`discount-badge-${p.id}`} className="absolute top-3 right-3 bg-rose-600 text-white border-0 font-extrabold shadow-lg">
            {discountPct(p)}% OFF
          </Badge>
        )}
        <div className="absolute bottom-3 right-3 flex items-center gap-1 bg-white/90 text-slate-900 text-xs font-bold px-2 py-1 rounded-full">
          <Play className="h-3 w-3 fill-current" /> Real Stock Video
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading font-bold text-sm leading-snug line-clamp-2 min-h-[2.5rem]">{p.title}</h3>
        <div className="mt-2 flex items-center gap-2 text-xs text-muted-foreground font-medium">
          <span className="px-2 py-0.5 rounded bg-secondary font-mono">{p.size}</span>
          {p.pan_india && <span data-testid={`pan-india-${p.id}`} className="px-2 py-0.5 rounded bg-primary/10 text-primary font-bold">PAN India</span>}
        </div>
        <div className="mt-3 flex items-end justify-between">
          <div>
            <div className="flex items-baseline gap-1.5">
              <span className="text-primary font-heading font-extrabold text-lg">{priceMain(p)}</span>
              {priceActual(p) && <span className="text-[11px] text-muted-foreground line-through">{priceActual(p)}</span>}
            </div>
            {priceBox(p) && <div className="text-[11px] text-muted-foreground font-semibold">{priceBox(p)}</div>}
            <div className="text-[11px] font-semibold text-emerald-600 flex items-center gap-1">
              <Layers className="h-3 w-3" /> {p.stock_qty} {stockUnit(p)} in stock
            </div>
          </div>
          <div className="text-right text-xs text-muted-foreground flex items-center gap-1 font-medium">
            <MapPin className="h-3 w-3" /> {p.city}
          </div>
        </div>
      </div>
    </div>
  );
}
